import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/917017798524?text=Hello%20Tour%20Trips%20India%2C%20I%27d%20like%20to%20plan%20a%20trip"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 bg-[#25D366] text-white rounded-full pl-4 pr-5 py-3 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
    >
      <span className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
      </span>
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm font-medium tracking-wide">Chat with us</span>
    </a>
  );
}
